import dayjs from 'dayjs';

const formatTimestampAsParameter = (
  timestamp: string,
) => dayjs(timestamp).format('YYYYMMDD');

export default formatTimestampAsParameter;
